<template>
  <div
    id="lcly-button-0"
    data-switchlive="true" 
    data-switchlive-impression="true"
    data-switchlive-impression-id-PL="1"
  >
    <a 
      id="lcly-link-0" 
      data-switchlive="true"
      data-switchlive-mode="auto"
      data-switchlive-id-PL="6"
      href="https://brands.locally.com" 
      target="_blank"
    >
      <span v-html="bp('locallyLink')"/>
    </a>
  </div>
</template>

<script>
import {Url} from '@/utils/url';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    locallyConfig() {
      return {
        company_name: this.options.companyName,
        company_id: this.options.companyId,
        inline: '1',
        lang: this.$store.state.locale.toLowerCase().replace(/_/g, '-'),
        no_link: '1',
      };
    },
    locallyQuery() {
      return Url.objectToQueryStringArray(this.locallyConfig).join('&');
    },
  },
  mounted() {
    this.appendLocallyScript();
  },
  methods: {
    appendLocallyScript() {
      const script = document.createElement('script');
      script.src = `${this.options.baseUrl}/stores/map.js?${this.locallyQuery}`;
      document.head.appendChild(script);

      const switchLiveScript = document.createElement('script');
      switchLiveScript.id = "lcly-script-switchlive-0";
      switchLiveScript.async = true;
      switchLiveScript.src = `${this.options.baseUrl}/js/switchlive.js?company_id=${this.options.companyId}`;
      document.head.appendChild(switchLiveScript);

      const switchLiveEventsScript = document.createElement('script');
      switchLiveEventsScript.id = "lcly-script-switchlive-events-0";
      switchLiveEventsScript.async = true;
      switchLiveEventsScript.src = `${this.options.baseUrl}/switchlive/switchlive-events.js?company_id=${this.options.companyId}`; 
      document.head.appendChild(switchLiveEventsScript);

      const switchLiveConfigScript = document.createElement('script');
      switchLiveConfigScript.id = "lcly-switchlive-config-0";
      document.head.appendChild(switchLiveConfigScript);
    },
  },
};
</script>